<template>
    <AppModal ref="modal" :title="$t('categoryCard.labels.category_structure')">
        <div class="modal-body">
            <CategoryTreeComponent
                @update:selectedCategory="$emit('update:selectedCategory', $event)"
                :selectedSourceId="selectedSourceId"
                :targetIntegrationService="targetIntegrationService"
            />
        </div>
        <div class="modal-footer">
            <AppButton color="indigo" @click="$refs.modal.hide()">
                {{ $t("buttons.select") }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from "../../../../../../../js/components/new/modal/AppModal.vue";
import AppButton from "../../../../../../components/new/button/AppButton.vue";
import CategoryTreeComponent from "../../../compare/CategoryTreeComponent.vue";

export default {
    name: "CategoryTreeModal",
    components: {
        AppModal, AppButton, CategoryTreeComponent
    },
    props: {
        selectedSourceId: {
            type: Number,
            default: null
        },
        targetIntegrationService: {
            type: String,
            required: true
        }
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        }
    }
}
</script>